import React, {
  FC, MouseEvent, RefObject,
} from 'react';

type Props = {
  label: string;
  disabled?: boolean;
  size?: 'small' | 'default' | 'large';
  type?: 'default' | 'text' | 'dimmed';
  icon?: '' | 'add' | 'attachment' | 'award' | 'bike' | 'bookmark' | 'brand-linkedin' | 'brand-mendeley' | 'brand-orcid' | 'brand-researchgate' | 'brand-twitter' | 'calendar' | 'camera' | 'car' | 'class' | 'close' | 'collapse' | 'confirm' | 'confirm-circle' | 'context-menu' | 'copy' | 'current-semester' | 'dark-mode' | 'delphinus' | 'delete' | 'design' | 'download' | 'edit' | 'email' | 'exam' | 'expand' | 'failed' | 'failed-circle' | 'file' | 'filter' | 'finish' | 'heart' | 'hide' | 'infinity' | 'info' | 'info-circle' | 'instructor' | 'instructor-with-class' | 'language' | 'location' | 'link-chain' | 'link-internal' | 'link-external' | 'link-external-square' | 'lms-course-common' | 'lms-course-sections' | 'lms-course-additional' | 'lms-course-merge-with' | 'lms-course-merged' | 'mailbox' | 'menu' | 'news' | 'next' | 'note' | 'notifications' | 'passed-exemption' | 'phone' | 'phone-landline' | 'previous' | 'print' | 'public-transport' | 'receipt' | 'refresh' | 'reorder' | 'replay' | 'route' | 'search' | 'season-autumn' | 'season-christmas' | 'season-easter' | 'season-halloween' | 'season-spring' | 'season-summer' | 'season-winter' | 'send' | 'settings' | 'source-system' | 'student-place-accepted' | 'student-place-not-offered' | 'student-place-offered' | 'student-place-rejected' | 'student-place-standby' | 'sign-in' | 'sign-out' | 'spock' | 'sync' | 'theme-chooser' | 'tip' | 'tools' | 'tooltip' | 'upload' | 'user-profile' | 'user-impersonation' | 'view' | 'viewport-default' | 'viewport-medium' | 'viewport-wide' | 'walking' | 'warning' | 'warning-triangle';
  iconPosition?: 'left' | 'right';
  hideLabel?: boolean;
  mode?: 'none' | 'ireversable-action' | 'confirmable-action' | 'processing' | 'ireversable-action processing' | 'confirmable-action processing', // (sic)
  btnRef?: React.RefObject<HTMLButtonElement>;
  classNames?: string[];
  ariaExpanded?: boolean;
  ariaHasPopup?: boolean;
  asSubmit?: boolean;
  onClick?: (
    event: React.MouseEvent<HTMLButtonElement>,
    ref: React.RefObject<HTMLButtonElement> | undefined,
  ) => void;
};

const AUButtonComponent: FC<Props> = ({
  label,
  disabled = false,
  size = 'default',
  type = 'default',
  icon = '',
  iconPosition = 'left',
  hideLabel = false,
  mode = 'none',
  btnRef,
  classNames = [],
  ariaExpanded = false,
  ariaHasPopup = undefined,
  asSubmit = false,
  onClick = (
    event: MouseEvent<HTMLButtonElement>,
    ref: RefObject<HTMLButtonElement> | undefined,
  ) => {
    // eslint-disable-next-line no-console
    console.log(event, ref);
  },
}) => {
  const sizeClass = size === 'default' ? '' : `button--${size}`;
  const typeClass = type === 'default' ? '' : `button--${type}`;
  let iconClass = '';
  if (icon) {
    iconClass = `button--icon icon-${icon}`;
    if (iconPosition) {
      iconClass = `${iconClass} button--icon--${iconPosition}`;
    }

    if (hideLabel) {
      iconClass = `${iconClass} button--icon--hide-label`;
    }
  }
  let modeClass = '';
  if (mode && mode !== 'none') {
    modeClass = mode.includes(' ') ? mode.split(' ').map((m) => `button--${m}`).join(' ') : `button--${mode}`;
  }

  return (
    <button
      ref={btnRef}
      type={asSubmit ? 'submit' : 'button'}
      disabled={disabled}
      className={[
        'button',
        sizeClass,
        typeClass,
        iconClass,
        modeClass,
        disabled && !mode?.includes('processing') ? 'visually-disabled' : '',
      ].concat(classNames || []).join(' ').replace(/\s+/g, ' ').trim()}
      title={icon && hideLabel ? label : undefined}
      aria-expanded={ariaExpanded}
      aria-haspopup={ariaHasPopup}
      onClick={(event: MouseEvent<HTMLButtonElement>) => {
        if (typeof onClick !== 'undefined') {
          onClick(event, btnRef);
        }
      }}
    >
      {label}
    </button>
  );
};

AUButtonComponent.displayName = 'AUButtonComponent';
export default AUButtonComponent;

export {
  Props,
};
